<template>
  <TableActionBar position="bottom">
    <div class="flex-1"></div>
    <Pagination :itemCount="85" />
  </TableActionBar>
</template>

<script>
import { Pagination } from '@listen360/alexandria'

export default {
  name: 'ReportsTableBottomActionBar',
  components: {
    Pagination
  }
}
</script>
